var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { useContext } from 'react';
import { canExpand, getTemplate, getUiOptions, } from '@rjsf/utils';
import { Button, Grid, Stack } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { ArrayFieldItemContext } from './ArrayFieldItemContext';
export var ObjectFieldTemplate = function (props) {
    var title = props.title, description = props.description, required = props.required, properties = props.properties, disabled = props.disabled, readonly = props.readonly, idSchema = props.idSchema, uiSchema = props.uiSchema, schema = props.schema, formData = props.formData, onAddClick = props.onAddClick, registry = props.registry;
    var uiOptions = getUiOptions(uiSchema);
    var TitleField = getTemplate('TitleFieldTemplate', registry, uiOptions);
    var DescriptionField = getTemplate('DescriptionFieldTemplate', registry, uiOptions);
    var isInArrayFieldItemTemplate = useContext(ArrayFieldItemContext);
    return (React.createElement(React.Fragment, null,
        (uiSchema['ui:title'] || title) &&
            isInArrayFieldItemTemplate == null ? (React.createElement(TitleField, { id: "".concat(idSchema.$id, "-title"), title: title, required: required, schema: schema, registry: registry })) : null,
        description && isInArrayFieldItemTemplate == null ? (React.createElement(DescriptionField, { id: "".concat(idSchema.$id, "-description"), description: description, schema: schema, registry: registry })) : null,
        React.createElement(Stack, { spacing: 2 },
            properties.map(function (element) { return element.content; }),
            canExpand(schema, uiSchema, formData) && (React.createElement(Grid, { container: true, justifyContent: "flex-end" },
                React.createElement(Grid, { item: true },
                    React.createElement(AddButton, { className: "object-property-expand", onClick: onAddClick(schema), disabled: disabled || readonly })))))));
};
var AddButton = function (props) { return (React.createElement(Button, __assign({}, props, { color: "secondary" }),
    React.createElement(AddIcon, null),
    " Add Item")); };
export default ObjectFieldTemplate;
